<template>
  <div v-if="isLoading" class="d-flex justify-content-center align-items-center h-100">
    <Preloader />
  </div>
  <EditProfile v-else :userId="userId" :userData="tableDataEdit" @close="onCloseClick" :isUserProfile="false"
    @profileUpdate="onProfileUpdate" @avatarUpdate="onAvatarUpdate" isMyProfile :breadcrumbs="[
      {
        text: 'Home',
        to: { name: 'home' },
      },
      {
        text: 'My profile',
        click: () => onCloseClick(),
      }
    ]" />
</template>

<script>
import { mapGetters } from 'vuex'
import EditProfile from '@components/EditProfile'
import UserMixin from '@mixins/UserMixin'
import Preloader from '@components/Preloader'

export default {
  name: 'MyProfileEdit',
  mixins: [UserMixin],
  components: { EditProfile, Preloader },
  data () {
    return {
      editProfile: {
        showModal: false,
        form: {
          'name': {
            type: 'input',
            name: 'name',
            label: 'Name',
            placeholder: 'Name',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'position': {
            type: 'input',
            name: 'position',
            label: 'Position',
            placeholder: 'Position',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          }
        }
      },
      table: {
        items: {},
        informationTableFields: [
          {
            key: 'payment_type',
            label: 'Payment type'
          },
          {
            key: 'employment_type',
            label: 'Employment type',
            isObject: 'name',
            class: 'text-lowercase'
          },
          {
            key: 'allocations',
            label: 'Allocation',
            isArray: true,
            isObject: 'name'
          },
          {
            key: 'availability',
            label: 'Availability',
            isObject: 'name'
          },
          {
            key: 'years_of_experience',
            label: 'Experience'
          },
          {
            key: 'seniority_lvl',
            label: 'Seniority level',
            isObject: 'name'
          },
          {
            key: 'english_lvl',
            label: 'English level',
            isObject: 'name'
          },
          {
            key: 'roles',
            label: 'Role',
            isArray: true,
            isObject: 'display_name'
          },
          {
            key: 'cv_link',
            label: 'CV',
            isLink: true
          }
        ],
        personalInformationTableFields: [
          {
            key: 'skype',
            label: 'Skype',
            icon: 'skype'
          },
          {
            key: 'telegram',
            label: 'Telegram',
            icon: 'telegram'
          },
          {
            key: 'email',
            label: 'Email',
            icon: 'email'
          },
          {
            key: 'mobile',
            label: 'Phone',
            icon: 'phone'
          },
          {
            key: 'other',
            label: 'Other',
            icon: 'calendar'
          }
        ]
      },
      userId: null,
      userAvatar: null,
      userName: '',
      userPosition: '',
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      getCurrentUserId: 'getCurrentUserId',
      getLoadedUser: 'users/getLoadedUser'
    }),
    tableData () {
      const data = this.table.items
      const contactData = data.contacts
      return { ...contactData, ...data }
    },
    tableDataEdit () {
      return Object.keys(this.table.items).length ? this.table.items : null
    }
  },
  async created () {
    this.isLoading = true

    if (this.getCurrentUserId === this.getLoadedUser?.id) {
      this.userId = this.getLoadedUser.id
      this.userAvatar = this.getLoadedUser.avatar_url
      this.userName = this.getLoadedUser.name
      this.userPosition = this.getLoadedUser.position

      this.fillEditUserForm(this.getLoadedUser)

      this.table.items = { ...this.getLoadedUser, roles: this.getLoadedUser.user_roles }

      this.isLoading = false
      return
    }

    await this.axios({
      method: 'get',
      url: `/api/authUser`,
      headers: {
        Authorization: 'Bearer' + localStorage.getItem('access_token')
      }
    }).then(response => {
      this.userId = response.data.id
      this.userAvatar = response.data.avatar_url
      this.userName = response.data.name
      this.userPosition = response.data.position

      this.editProfile.form.name.value = response.data.name
      this.editProfile.form.position.value = response.data.position

      const data = response.data
      this.fillEditUserForm(data)
      this.table.items = { ...data, roles: data.user_roles }
    })
      .catch(console.error)
      .finally(() => {
        this.isLoading = false
      })
  },
  methods: {
    onProfileUpdate (data) {
      this.userId = data.id
      this.userAvatar = data.avatar_url
      this.userName = data.name
      this.userPosition = data.position

      this.editProfile.form.name.value = data.name
      this.editProfile.form.position.value = data.position

      this.fillEditUserForm(data)
      this.table.items = { ...data, roles: data.roles }
      this.table.items = { ...data, user_roles: data.roles }

      this.$store.dispatch('setUser', { ...data, user_roles: data.roles, roles: data.roles })
      this.onCloseClick()
    },
    onAvatarUpdate (avatar) {
      this.userAvatar = avatar
    },
    onCloseClick () {
      this.$router.push({ name: 'my-profile' })
    }
  }
}
</script>

<style scoped lang="scss">

  .content-wrapper {
    background-color: #ffffff;
    border-radius: 10px;
  }

  .profile-avatar-wrapper {
    padding: 30px;
  }

  .information-wrapper {
    padding: 20px;
  }

  .user-avatar {
    width: 200px;
    height: 200px;
  }

  .info-item {
    margin-top: 10px;
  }

</style>
